import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import { List, Card, Icon, Popup } from 'semantic-ui-react';
import SetBonusTable from './SetBonusTable';

export default class ItemSetContent extends Component {

    render() {

        const {itemSet} = this.props;

        if(!itemSet) {
            return null;
        }

        const bonusTable = itemSet.Bonuses ?
                                <SetBonusTable bonuses={itemSet.Bonuses} name={itemSet.Name} /> :
                                'Bonuses are based on synergy crystal.  Click for details';

        const popup = <Popup
                        trigger={ <Link to={`/itemsets/${itemSet.Id}`}>{itemSet.Name.English}</Link>}
                        content={ bonusTable }
                        />

        return (
            <Card.Content>
                <List.Item>
                    <Icon name="sitemap" /> {popup}
                </List.Item>
            </Card.Content>
        );
    }
}

ItemSetContent.propTypes = {
    itemSet: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/itemsets/ItemSetContent.jsx